<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ItemToggle extends Vue {
  @Prop({ type: Array, required: true }) readonly items: { key: string, title: string }[]
  @Prop({ type: String, required: true }) readonly selected: string
  @Prop({ type: Boolean, default: false }) readonly hasBorder: boolean

  toggle(key: string) {
    this.$emit('toggle', key)
  }
}
</script>

<template>
  <div :class="`d-flex justify-content-end toggle-wrapper align-self-start ${hasBorder ? 'borderer' : ''}`">
    <button v-for="item in items" :key="item.key"
            :class="`btn small item-toggle ${selected == item.key ? '' : 'btn--white'}`"
            @click="toggle(item.key)">
      {{item.title}}
    </button>
  </div>
</template>

<style scoped lang="scss">
@import '../../assets/scss/variables';

.toggle-wrapper {
  border-radius: 8px;
  padding: 0;
  background: linear-gradient(to right, $main 0%, $main-hover 100%);

  &.borderer {
    padding: 2px;
  }

  :first-child {
    border-radius: 6px 0 0 6px;
  }

  :last-child {
    border-radius: 0 6px 6px 0;
  }

  .item-toggle {
    margin-left: 0;
    border: none;
    background: transparent;
    color: white;
    transition: all 0.3s ease;

    &.btn--white {
      color: $main;
      background-color: #ffffff;
    }
  }
}
</style>